/** Stable content adapter; authoring never rewrites this module. */
import { bindContent, contentCatalog } from "../content/catalog"
import type { EntityTileMeta } from "../map/map"
export let EntityTileTypes: string[] = contentCatalog.source.tiles.types
export let EntityTileCharacteristics = contentCatalog.tiles as Record<string, EntityTileMeta>

// Rebuild the complete table group during preparation; activation only assigns bindings.
bindContent(catalog => ({
    EntityTileTypes: catalog.source.tiles.types,
    EntityTileCharacteristics: catalog.tiles as Record<string, EntityTileMeta>,
}), next => {
    EntityTileTypes = next.EntityTileTypes
    EntityTileCharacteristics = next.EntityTileCharacteristics
})
